var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z","key":0}),React.createElement("rect",{"x":"2","y":"9","width":"4","height":"12","key":1}),React.createElement("circle",{"cx":"4","cy":"4","r":"2","key":2})]);
}

Linkedin.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","className":"feather feather-linkedin"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
